export enum BolusInformation {
  InitiatedAt = "initiated_at",
  StoppedAt = "stopped_at",
  TotalRequestedUnits = "total_requested_units",
  CorrectionBolus = "correction_bolus",
  BolusNow = "bolus_now",
  BolusLater = "bolus_later",
  RequestedDuration = "requested_duration",
  CarbsEntered = "carbs_entered",
  InsulinEntered = "insulin_entered",
  PumpCalculated = "pump_calculated",
}
